import { createContext, useContext, useState, ReactNode } from 'react';

type NewsletterContextType = {
	isOpen: boolean;
	setIsOpen: (open: boolean) => void;
	toggle: () => void;
};

const NewsletterContext = createContext<NewsletterContextType | undefined>(
	undefined,
);

export function NewsletterProvider({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);

	const toggle = () => setIsOpen((prev) => !prev);

	return (
		<NewsletterContext.Provider value={{ isOpen, setIsOpen, toggle }}>
			{children}
		</NewsletterContext.Provider>
	);
}

export function useNewsletter() {
	const context = useContext(NewsletterContext);
	if (!context) {
		throw new Error('useNewsletter must be used within NewsletterProvider');
	}
	return context;
}
